export default __webpack_public_path__ + "5512aae307e0e66647f7331506202205.png";